import React from 'react';
import { Section } from '../ui/Section';
import { Button } from '../ui/Button';
import { ShieldCheck, Lock, Zap } from 'lucide-react';
export function FinalCTA() {
  return <Section className="bg-dark-800 border-t border-dark-700 relative overflow-hidden" data-id="element-45">
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-full max-w-4xl h-[400px] bg-gold-600/10 blur-[150px] pointer-events-none" data-id="element-46" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-47">
        {/* Final Comparison */}
        <div className="text-center mb-16" data-id="element-48">
          <h2 className="text-3xl font-black text-white mb-10" data-id="element-49">
            ⚖️ ¿CUÁL ELEGÍS?
          </h2>

          <div className="grid md:grid-cols-2 gap-6" data-id="element-50">
            <div className="bg-dark-900 border border-red-900/30 p-8 rounded-2xl" data-id="element-51">
              <h3 className="text-xl font-bold text-red-500 mb-4" data-id="element-52">
                ❌ OPCIÓN 1
              </h3>
              <p className="text-gray-400 text-lg" data-id="element-53">
                Ir lento
                <br data-id="element-54" />
                Probar solo
              </p>
            </div>
            <div className="bg-dark-900 border border-gold-500/50 p-8 rounded-2xl shadow-gold-glow" data-id="element-55">
              <h3 className="text-xl font-bold text-green-500 mb-4" data-id="element-56">
                ✅ OPCIÓN 2
              </h3>
              <p className="text-white font-bold text-lg" data-id="element-57">
                Tener todo armado
                <br data-id="element-58" />Y avanzar rápido
              </p>
            </div>
          </div>
        </div>

        {/* CTA Box */}
        <div className="bg-dark-900 border-2 border-gold-500/30 rounded-3xl p-8 md:p-12 text-center" data-id="element-59">
          <h2 className="text-3xl md:text-4xl font-black text-white mb-10" data-id="element-60">
            ⏰ EL PRECIO CIERRA PRONTO
          </h2>

          <div className="flex flex-col md:flex-row justify-center gap-6 mb-10" data-id="element-61">
            <a href="https://checkout.cmdigitalpro.online/cart/54042050461980:1" target="_blank" rel="noopener noreferrer" className="bg-dark-800 p-6 rounded-xl border border-dark-700 flex-1 hover:border-gray-500 transition-colors cursor-pointer block text-center" data-id="element-62">
              <p className="text-gray-400 font-bold mb-2" data-id="element-63">📘 MEGA PACK</p>
              <p className="text-2xl text-white font-black" data-id="element-64">👉 $19.990</p>
            </a>
            <a href="https://checkout.cmdigitalpro.online/cart/54042053411100:1" target="_blank" rel="noopener noreferrer" className="bg-gold-500/10 p-6 rounded-xl border border-gold-500/50 flex-1 relative overflow-hidden hover:border-gold-400 transition-colors cursor-pointer block text-center" data-id="element-65">
              <div className="absolute top-0 right-0 bg-gold-500 text-black text-xs font-bold px-2 py-1 rounded-bl-lg" data-id="element-66">
                RECOMENDADO
              </div>
              <p className="text-gold-400 font-bold mb-2" data-id="element-67">
                🚀 SISTEMA COMPLETO ⭐
              </p>
              <p className="text-2xl text-white font-black" data-id="element-68">👉 $27.990</p>
            </a>
          </div>

          <Button size="xl" fullWidth className="mb-8 animate-pulse-slow" href="https://checkout.cmdigitalpro.online/cart/54042053411100:1" data-id="element-69">
            👉 QUIERO GENERAR INGRESOS AHORA
          </Button>

          <div className="flex flex-wrap justify-center gap-6 text-sm text-gray-400 font-medium" data-id="element-70">
            <div className="flex items-center gap-2" data-id="element-71">
              <Lock className="w-4 h-4 text-gold-500" data-id="element-72" /> Pago seguro
            </div>
            <div className="flex items-center gap-2" data-id="element-73">
              <Zap className="w-4 h-4 text-gold-500" data-id="element-74" /> Acceso inmediato
            </div>
            <div className="flex items-center gap-2" data-id="element-75">
              <ShieldCheck className="w-4 h-4 text-gold-500" data-id="element-76" /> Garantía 7 días
            </div>
          </div>
        </div>
      </div>
    </Section>;
}